import React, { useState } from 'react'
import {
  Divider,
  IconButton,
  makeStyles,
  Menu,
  MenuItem,
  Typography,
} from '@material-ui/core'
import { Menu as MenuIcon } from 'react-feather'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useProfile } from '../profile/ProfileProvider'
import { LanguageSwitcher } from './LanguageSwitcher'

const useButtonStyles = makeStyles((theme) => ({
  root: {
    color: theme.palette.getContrastText(theme.palette.primary.light),
  },
}))

const useInactiveStyles = makeStyles(() => ({
  root: {
    cursor: 'auto',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
}))

export function MainMenu(): React.ReactElement {
  const buttonClasses = useButtonStyles()
  const inactiveClasses = useInactiveStyles()
  const [anchorEl, setAncherEl] = useState<HTMLElement | null>(null)
  const { isAdmin, displayName } = useProfile()
  const { t } = useTranslation()

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAncherEl(event.currentTarget)
  }

  const handleClose = () => {
    setAncherEl(null)
  }

  const adminLinkData = [
    {
      id: 'manage-building-templates',
      to: '/building-templates',
      text: t('home.navigateToBuildingTemplatesPage'),
    },
    {
      id: 'manage-global-temperature-collections',
      to: '/global-temperature-collections',
      text: t('home.navigateToGlobalTemperatureCollectionsPage'),
    },
    {
      id: 'manage-global-pricing-models',
      to: '/global-pricing-models',
      text: t('home.navigateToGlobalPricingModelsPage'),
    },
    {
      id: 'manage-deleted-projects',
      to: '/deleted-projects',
      text: t('home.manageDeletedProjects'),
    },
    {
      id: 'manage-users',
      to: '/users',
      text: t('home.manageUsers'),
    },
    {
      id: 'manage-user-groups',
      to: '/user-groups',
      text: t('home.manageUserGroups'),
    },
  ]

  const adminItems = isAdmin
    ? [
        <Divider key="divider" />,
        adminLinkData.map(({ id, to, text }) => (
          <MenuItem
            key={id}
            id={id}
            component={Link}
            to={to}
            onClick={handleClose}
          >
            {text}
          </MenuItem>
        )),
      ]
    : null

  return (
    <div>
      <IconButton
        data-cy="main-menu"
        classes={buttonClasses}
        onClick={handleClick}
      >
        <MenuIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem classes={inactiveClasses}>
          <Typography>{displayName}</Typography>
        </MenuItem>
        <Divider />
        <MenuItem classes={inactiveClasses}>
          <LanguageSwitcher afterChange={handleClose} />
        </MenuItem>
        {adminItems}
      </Menu>
    </div>
  )
}
